import styled from 'styled-components';

export const StyledConfirmWrapper = styled.div`
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: ${({ theme }) => theme.greyishBrown};
`

export const StyledConfirmItem = styled.div`
    color: ${({ theme, green }) => green ? theme.grassyGreen : theme.greyishBrown};
`